import { getToken } from "../config/helpers";
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({ children }) => {
    return getToken() ? children : <Navigate to="/" />
}

export default ProtectedRoutes;
